'use strict';

export default class AdminController {
  /*@ngInject*/
  constructor(User, dialogs, Auth, DTOptionsBuilder, $uibModal, DTState, SettingsService) {
    // Use the User $resource to fetch all users
    this.users = User.query();
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.isSuperAdmin = Auth.isSuperAdminSync;
    this.isAdmin = Auth.isAdminSync;
    this.roles =  ["user", "admin","superadmin", "suite-user","suite-admin","suite-superadmin"]; //Config.getPlatformConfig().getUserRoles();
    this.Auth = Auth;
    this.User = User;

    SettingsService.getByName({name: 'client'}, clientData => {
      this.eVotingEnabled = clientData.data.eVotingEnabled;

      if (this.eVotingEnabled) {
        this.roles = this.roles.concat(['ev-user','ev-admin', 'ev-superadmin']);
      }
    });

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save())
      .withOption('stateLoadCallback', DTState.restore())
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: 'User List'
      },{
        extend: 'csv',
        title: 'User List'
      },{
        title: 'User List',
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'LETTER'
      },'print']);
  }

  patchUserRoles(user) {
    this.Auth.patchUserRoles(user);
  }

  openAddUserModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'schemaFormModal',
      resolve: {
        config: function() {
          return {
            title: "Add User",
            icon: "user-plus",
            intro: "<p>* Required</p>",
            outro: "<h5>If checked, the new user will get an invitation email with login instructions (including the initial password). If you are not sending out the invitation email, it is up to you to communicate the initial credentials to the new user!</h5>",
            schema: {
              type: "object",
              properties: {
                firstName: {
                  type: "string",
                  title: "First Name *"
                },
                lastName: {
                  type: "string",
                  title: "Last Name *"
                },
                email: {
                  type: "string",
                  title: 'Email *',
                  pattern: "^\\S+@\\S+$",
                  validationMessage: "Must be a valid email"
                },
                password: {
                  type: "string",
                  title: "Initial Password *"
                },
                sendInvitationEmail: {
                  type: "boolean",
                  title: "Send Invitation Email"
                }
              },
              required: ["firstName", "lastName", "email", "password"]
            }
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (newUser) {
        that.User.save(newUser, _=> {
          that.users = that.User.query();
        }, err=>{
          console.log("the user could not be created");
        })
      },
      function () { /* cancel */ }
    );

  }

  delete(user) {

    var userStr = "<br/><br/><b>" + user.firstName + ' ' + user.lastName + "</b>";
    var dlg = this.dialogs.confirm("Delete user?", "Do you really want to delete this user?" + userStr);
    dlg.result.then(() => {
      /* Delete the user */
      user.$remove();
      this.users.splice(this.users.indexOf(user), 1);
    }, () => {
      // Cancel
    });

  }
}



// WEBPACK FOOTER //
// ./client/app/admin/user-list/admin.controller.js